<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="purchaseorder" />
        <MenuStockList/>
        <PurchaseOrderNewList :page_id="$store.state.purchaseOrderNewDetailId"/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import PurchaseOrderNewList from '@/components/menuadmin/stock/stocklist/PurchaseOrderNewList.vue'

export default {
    name:'purchaseOrderNewDetail',
    components:{
        HeaderStock,
        MenuStockList,
        PurchaseOrderNewList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>